<template>
  <NotiSettingsBody/>
</template>

<script>
// @ is an alias to /src
import NotiSettingsBody from '@/components/NotiSettingsBody.vue'

export default {
  name: 'NotiSettingsView',
  components: {
    NotiSettingsBody
  }
}
</script>
